/** TanStack Query hooky nad katalogovým API. */

import { useMutation, useQuery } from '@tanstack/react-query';
import { api, type OrderCreateBody, type PaymentMethod, type ProductFilters } from './api';

const STALE = 60_000; // katalog se nemění po vteřinách

export function useCategories() {
  return useQuery({
    queryKey: ['categories'],
    queryFn: () => api.categories(),
    staleTime: STALE,
  });
}

export function useSubjects() {
  return useQuery({
    queryKey: ['subjects'],
    queryFn: () => api.subjects(),
    staleTime: STALE,
  });
}

export function useProducts(filters: ProductFilters = {}) {
  return useQuery({
    queryKey: ['products', filters],
    queryFn: () => api.products(filters),
    staleTime: STALE,
  });
}

export function useProduct(slug: string | undefined) {
  return useQuery({
    queryKey: ['product', slug],
    queryFn: () => api.product(slug as string),
    enabled: Boolean(slug),
    staleTime: STALE,
  });
}

export function useSample(slug: string | undefined) {
  return useQuery({
    queryKey: ['sample', slug],
    queryFn: () => api.sample(slug as string),
    enabled: Boolean(slug),
    staleTime: STALE,
  });
}

/* Objednávky / checkout */

/** Vytvoření objednávky (`POST /orders`). */
export function useCreateOrder() {
  return useMutation({
    mutationFn: (body: OrderCreateBody) => api.createOrder(body),
  });
}

/**
 * Stav objednávky (`GET /orders/{token}`). Při `poll` obnovuje ~4 s
 * (živý stav „Čekáme na platbu…"). Data se nikdy neukládají „na dlouho".
 */
export function useOrder(token: string | undefined, opts: { poll?: boolean } = {}) {
  return useQuery({
    queryKey: ['order', token],
    queryFn: () => api.order(token as string),
    enabled: Boolean(token),
    staleTime: 0,
    refetchInterval: opts.poll ? 4000 : false,
    refetchOnWindowFocus: true,
  });
}

/** Volba platební metody (`POST /orders/{token}/pay`). */
export function usePay(token: string | undefined) {
  return useMutation({
    mutationFn: (method: PaymentMethod) => api.pay(token as string, method),
  });
}
